import { Action } from '@ngrx/store';
import { Plant, IProduct } from '@cemex-core/cmx-api';

export enum OneClickPlantsActionTypes {
  LOAD_PLANTS = '[One Click] Load plants',
  LOAD_PLANTS_COMPLETE = '[One Click] Load plants completed',
  SELECT_PLANTS = '[One Click] Select plants',
  RESET = '[One Click] plants reset',
}

export class OneClickLoadPlantsAction implements Action {
  readonly type = OneClickPlantsActionTypes.LOAD_PLANTS;

  constructor(public payload: IProduct, public index: number) {}
}

export class OneClickLoadPlantsCompleteAction implements Action {
  readonly type = OneClickPlantsActionTypes.LOAD_PLANTS_COMPLETE;

  constructor(public payload: Plant[], public index: number) {}
}

export class OneClickSelectPlantsAction implements Action {
  readonly type = OneClickPlantsActionTypes.SELECT_PLANTS;

  constructor(public payload: Plant, public index: number) {}
}

export class OneClickResetPlantsAction implements Action {
  readonly type = OneClickPlantsActionTypes.RESET;

  constructor() {}
}

export type OneClickPlantsActions =
  | OneClickLoadPlantsAction
  | OneClickLoadPlantsCompleteAction
  | OneClickSelectPlantsAction
  | OneClickResetPlantsAction;
